import { css, SerializedStyles } from '@emotion/core'

import { Color } from '../../../enums/color'
import { StyledComponent } from '../../../types/styledComponent'

export const getErrorStyle = (Control: StyledComponent, checked: boolean): SerializedStyles => css`
  ${Control} {
    box-shadow: none;

    ${checked
      ? css`
          color: ${Color.White};
          background-color: ${Color.Red700};
          border-color: transparent;
        `
      : css`
          border-color: ${Color.Red700};
        `};
  }
`
